export default __webpack_public_path__ + "i18n/ru.81ee19e1f38a81837a53ab12716264bb.json";